  <template>
  <div>
    <div v-if="payload.data">
      <LinkEntity :payload="payload.data" />
    </div>
    <div v-if="form">
      <div dir="ltr" style="text-align: left; float: left;">
        <snooze v-model="timing" :selected_date="form.data.alert.fields.timing.value" style="margin-top: 20px;"></snooze>
      </div>
      <div>
        <p class="bold">status</p>
        <select dir="rtl" v-model="form.data.alert.fields.status.value">
          <option value="active">active</option>
          <option value="in_progress">in_progress</option>
          <option value="done">done</option>
          <option value="irrelevant">irrelevant</option>
        </select>
      </div>
      <div v-if="!payload.is_create">
        <p class="bold">title</p>
        <input
          v-model="form.data.alert.fields.title.value"
          class="outlined full_width"
          placeholder="כותרת המשימה"
        />
      </div>
      <div>
        <p class="bold">designator</p>
        <select dir="rtl" v-model="form.data.alert.fields.designator.value">
          <option v-for="option in designatorOptions.text" :key="option">{{option}}</option>
        </select>
      </div>
      <div>
        <p class="bold">content <span v-if="contentMandatory" class="red_text">(חובה למלא)</span></p>
        <textarea
          v-model="form.data.alert.fields.content.value"
          style="min-width: 370px;"
          class="outlined full_width"
          :class="{ field_error: form.data.alert.fields.content.has_error }"
          placeholder="תוכן המשימה"
        />
      </div>
      <div>
        <p class="bold">priority</p>
        <select dir="rtl" v-model="form.data.alert.fields.priority.value">
          <option v-for="index in 100" :key="index">{{index}}</option>
        </select>
      </div>
      <div>
        <p class="bold">owner</p>
        <select dir="rtl" v-model="form.data.alert.fields.owner.value">
          <option v-for="option in dropdownAdminsNames" :key="option">{{option}}</option>
        </select>
        <!-- Display created_at formatted with moment -->
        <p class="my-5">Created At: {{ formattedCreatedAt }}</p>
      </div>
    </div>
    <div class="modal_footer is-justify-content-space-between">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
      <div class="is-flex is-align-items-center">
        <p v-if="alertId" class="mx-3">id: {{ alertId }}</p>
        <!-- Editable minimum_permission -->
        <div class="mx-3">
          <span v-if="!isEditingMin" @click="isEditingMin = true">
            min: {{ form.data.alert.fields.minimum_permission.value }}
          </span>
          <input
            v-else
            class="input"
            v-model.number="form.data.alert.fields.minimum_permission.value"
            @blur="updatePermission('min')"
            type="number"
            min="0"
            max="100"
            style="width: 50px;"
          />
        </div>
        <!-- Editable maximum_permission -->
        <div class="mx-3">
          <span v-if="!isEditingMax" @click="isEditingMax = true">
            max: {{ form.data.alert.fields.maximum_permission.value }}
          </span>
          <input
            v-else
            class="input"
            v-model.number="form.data.alert.fields.maximum_permission.value"
            @blur="updatePermission('max')"
            type="number"
            min="0"
            max="100"
            style="width: 50px;"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import TextsHelper from '@/custom/classes/texts_helper.js'
import Snooze from '@/components/Snooze'
import LinkEntity from '@/components/LinkEntity'

export default {
  name: 'admin-alerts-form',
  components: {
    Snooze,
    LinkEntity
  },
  props: {
    payload: {
      type: Object
    },
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      texts_helper: new TextsHelper(),
      is_loading: false,
      timing: undefined,
      form: undefined,
      alert: undefined,
      isEditingMin: false,
      isEditingMax: false
    }
  },
  computed: {
    ...mapGetters('feedDesignators', ['designatorOptions', 'fullFeedDesignator']),
    ...mapGetters('admins', ['dropdownAdminsNames']),
    contentMandatory () {
      if (this.payload.hasOwnProperty('isContentMandatory')) {
        return this.payload.isContentMandatory
      }
      return this.payload.resource_type != 'Position'
    },
    alertId () {
      return this.payload.data && this.payload.data.id
    },
    formattedCreatedAt () {
      if (this.form && this.form.data.alert.fields.created_at) {
        return this.$moment(this.form.data.alert.fields.created_at.value).format('DD/MM/YYYY')
      }
      return ''
    }
  },
  watch: {
    'form.data.alert.fields.designator.value' (newVal) {
      const feed = this.fullFeedDesignator.find(d => d.designator == newVal)
      const data = this.payload.data || {}
      let min = data.minimum_permission == 0 ? data.minimum_permission : data.minimum_permission || this.payload.minimum_permission || feed.minimum_permission
      let max = data.maximum_permission || this.payload.maximum_permission || feed.maximum_permission
      if (this.form.data.alert.fields.priority.value == 88 && newVal == 'new_lead') {
        min = 6
        max = 9
      }
      this.form.data.alert.fields.minimum_permission.value = min
      this.form.data.alert.fields.maximum_permission.value = max
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        const designator = this.payload.init_designator || 'manual_input'
        const feed = this.fullFeedDesignator.find(d => d.designator == designator)
        this.setForm({
          id: '',
          status: 'active',
          designator: designator,
          content: this.payload.initContent || '',
          priority: this.payload.init_priority || feed.priority,
          owner: this.payload.isNoOwner ? null : this.payload.init_owner || this.$utils.getOwner().name,
          resource_type: this.payload.resource_type,
          resource_id: this.payload.resource_id,
          timing: new Date().toUTCString(),
          minimum_permission: this.payload.minimum_permission || feed.minimum_permission,
          maximum_permission: this.payload.maximum_permission || feed.maximum_permission,
          created_at: new Date().toISOString()
        })
        return
      }
      this.$network_utils.getAlert(this.payload.data.id).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        alert: {
          fields: {
            status: {
              value: form_data.status,
              has_error: false,
              validations: []
            },
            title: {
              value: form_data.title,
              has_error: false,
              validations: []
            },
            designator: {
              value: form_data.designator,
              has_error: false,
              validations: []
            },
            timing: {
              value: form_data.timing,
              has_error: false,
              validations: []
            },
            content: {
              value: form_data.content,
              has_error: false,
              validations: this.payload.resource_type != 'Position' ? ['Exists'] : []
            },
            resource_type: {
              value: form_data.resource_type,
              has_error: false,
              validations: []
            },
            resource_id: {
              value: form_data.resource_id,
              has_error: false,
              validations: []
            },
            priority: {
              value: form_data.priority,
              has_error: false,
              validations: []
            },
            minimum_permission: {
              value: form_data.minimum_permission,
              has_error: false,
              validations: []
            },
            maximum_permission: {
              value: form_data.maximum_permission,
              has_error: false,
              validations: []
            },
            owner: {
              value: form_data.owner,
              has_error: false,
              validations: []
            },
            created_at: {
              value: form_data.created_at,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/alerts/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    async updatePermission (field) {
      try {
        let updateData = {}
        if (field === 'min') {
          this.isEditingMin = false
          updateData.minimum_permission = this.form.data.alert.fields.minimum_permission.value
        } else if (field === 'max') {
          this.isEditingMax = false
          updateData.maximum_permission = this.form.data.alert.fields.maximum_permission.value
        }
        await this.$network_utils.updateAlert({
          id: this.alertId,
          ...updateData
        })
        this.$utils.emit('show_toast', { text: 'Permission updated successfully' })
      } catch (error) {
        this.$utils.emit('show_toast', { text: 'Failed to update permission' })
      }
    },
    async submit () {
      if (this.payload.suitcase) {
        const special = await this.alertDesignatedPosition()
        if (special) return
      }
      let bold_content = this.texts_helper.getBoldContent(this.form.data.alert.fields.content.value, this.form.data.alert.fields.designator.value)
      if (bold_content == 'problem') {
        return
      }
      this.form.data.alert.fields.content.value = bold_content
      this.form.data.alert.fields.timing.value = this.timing
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        if (this.timing != undefined) {
          this.$network_utils.postStat({
            title: 'new internal note',
            designator: 'internal_notes',
            content: `Alert (ID: ${response[0].id}) Set Timing To <b>${new Date(this.form.data.alert.fields.timing.value).toLocaleString()}</b>`,
            status: 'done',
            owner: this.$utils.getOwner().name,
            priority: 4,
            resource_type: this.payload.resource_type,
            resource_id: this.payload.resource_id
          })
        }
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
        this.onSubmit(this.payload)
      })
    },
    async alertDesignatedPosition () {
      const [alert] = await this.$network_utils.getAllAlerts({ current_resource_type: this.payload.resource_type, current_resource_id: this.payload.resource_id, designators: 'designated_position', statuses: 'in_progress,active' })
      if (alert) {
        if (alert.status == 'active') {
          const data = this.form.getData(this.form.data.alert)
          await this.$network_utils.updateAlert({ id: alert.id, owner: data.owner, priority: data.priority, timing: data.timing })
          this.remove(this.payload)
        } else {
          this.$utils.emit('show_toast', { text: `${alert.owner} עובדת על המשרה כרגע` })
        }
        return true
      }
      return false
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
